var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 15
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.9,
  d: "m3.9 9.051-2.62-2.62a.507.507 0 0 0-.71 0l-.14.138a.5.5 0 0 0-.007.702l3.366 3.367a1.005 1.005 0 0 0 1.422 0L8.577 7.27a.5.5 0 0 0-.008-.702l-.138-.138a.5.5 0 0 0-.711 0L5.1 9.052v-7.55A.506.506 0 0 0 4.598 1h-.196a.5.5 0 0 0-.502.502zM9 12.302v.196a.51.51 0 0 1-.51.502H.51a.5.5 0 0 1-.51-.502v-.196a.51.51 0 0 1 .51-.502h7.98c.288 0 .51.225.51.502"
})));
export default SvgIconDownload;